import type { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

import { URL_PATTERN } from '../regex-patterns';
import { trimUrl } from './soft-url-validator';

export function potentialUrlValidator(control: FormControl<string>): { url: boolean } | null {
  const trimmed = trimUrl(control.value);
  return isEmpty(trimmed) || URL_PATTERN.test(trimmed) ? null : { url: true };
}
